module.exports = __webpack_public_path__ + "static/media/18ECA27.2fac0078.jpg";